export const getQRExpirationTime = [
  {
    label: "NO",
    value: null
  },
  {
    label: "5 min",
    value: 5
  },
  {
    label: "10 min",
    value: 10
  },
  {
    label: "15 min",
    value: 15
  },
  {
    label: "30 min",
    value: 30
  },
  {
    label: "45 min",
    value: 45
  },
  {
    label: "1 hora",
    value: 60
  },
  {
    label: "2 horas",
    value: 120
  },
  {
    label: "3 horas",
    value: 180
  }
];

export const getDateFilter = [
  {
    label: "Hoy",
    value: "today"
  },
  {
    label: "Último mes",
    value: "lastMonth"
  },
  {
    label: "Últimos 3 meses",
    value: "last3Month"
  },
  {
    label: "Últimos 6 meses",
    value: "last6Month"
  },
  {
    label: "Último año",
    value: "lastYear"
  }
];

export const getProductType = [
  {
    label: "Todos",
    value: "all"
  },
  {
    label: "Bebidas",
    value: process.env.VUE_APP_PRODUCT_TYPE_DRINKS_ID
  },
  {
    label: "Comidas",
    value: process.env.VUE_APP_PRODUCT_TYPE_FOOD_ID
  },
  {
    label: "Postres",
    value: process.env.VUE_APP_PRODUCT_TYPE_DESSERT_ID
  }
];
